<template>
  <div>
    <span class="check-box" @click="check" v-bind:class="{ 'checked': selected }"></span>
  </div>
</template>

<script>
  export default {
    data: () => ({
      selected: false
    }),
    props: {
      toggleChecked: {
        type: Function,
        required: true
      },
      checkedDefault: {
        type: Boolean,
        default: false
      },
      value: {
        type: [String, Number],
        required: true
      },
      toggleCheckedOnMounted: {
        type: Boolean,
        required: false
      }
    },
    mounted () {
      this.selected = this.checkedDefault

      if (this.toggleCheckedOnMounted) {
        this.toggleChecked(this.selected, this.value)
      }
    },
    methods: {
      check () {
        this.selected = !this.selected
        this.toggleChecked(this.selected, this.value)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Checkbox.vue?05a64126